<template>
	<div>
		<b-navbar fixed="top" variant="white" class="shadow">
			<div class="container">
				<b-navbar-brand :to="{ name: 'components' }">
					<img
						:src="require('@/assets/img/logo.jpg')"
						alt="Mobil"
						class="img-fluid"
						style="height: auto; width: 100%; max-width: 150px"
					/>
				</b-navbar-brand>
			</div>
		</b-navbar>
		<div class="container mt-4 text-dark" style="padding-top: 80px">
			<h1 class="mb-4 text-dark">AVISO DE PRIVACIDAD</h1>
			<p>
				<span
					>&ldquo;LA GRAN CARRERA MOBIL&rdquo; del 20 de agosto del 2021 al 25
					de octubre del 2021. IMAQUINANDO S.A. DE C.V. con domicilio en Av.
					Amores 1153 &ndash; 2 Col del Valle Centro, alcald&iacute;a Benito
					Ju&aacute;rez, 03100, en la Ciudad de M&eacute;xico, es responsable de
					la confidencialidad, uso y protecci&oacute;n de la informaci&oacute;n
					personal que nos llegare a proporcionar por los distintos medios que
					utilizamos para la difusi&oacute;n de bienes y servicios. Por lo
					anterior su informaci&oacute;n personal ser&aacute; utilizada para
					fines de identificaci&oacute;n en cualquier tipo de relaci&oacute;n
					jur&iacute;dica o de negocios que realice con nosotros, incluyendo la
					venta y adquisici&oacute;n de los productos o servicios ofertados,
					hacerle llegar los productos adquiridos, enviarle nuestro catalogo de
					promociones, productos y servicios, invitarle a participar en eventos,
					concursos y sorteos y para fines mercadol&oacute;gicos y de
					prospecci&oacute;n comercial. Para las finalidades anteriores,
					podr&iacute;amos requerirle su nombre, direcci&oacute;n,
					tel&eacute;fono, correo electr&oacute;nico, RFC, fecha y lugar de
					nacimiento, sexo, nacionalidad, edad, informaci&oacute;n crediticia y
					patrimonial. Para el caso que se desee limitar el uso o
					divulgaci&oacute;n de su informaci&oacute;n personal, ejercitar sus
					derechos de acceder, rectificar y cancelar sus datos personales,
					as&iacute; como de oponerse al tratamiento de los mismos y revocar el
					consentimiento que para tal fin nos haya otorgado, lo podr&aacute;
					realizar a trav&eacute;s de los siguientes canales de atenci&oacute;n:
					Centro de atenci&oacute;n Telef&oacute;nica a los tel&eacute;fonos
					5556884444 y 5591972000 o a trav&eacute;s del correo
					electr&oacute;nico&nbsp;</span
				><a href="mailto:hola@imakinando.mx" class=""
					><span>hola@imakinando.mx</span></a
				><span
					>. En ambos casos se le informar&aacute;n los procedimientos a seguir.
					Le informaremos que sus datos personales no ser&aacute;n transferidos
					a terceros para fines distintos a los necesarios para brindarle
					oportunamente los servicios y/o productos adquiridos, su
					participaci&oacute;n en cualquier concurso o sorteo y entrega de sus
					premios, salvaguardando su protecci&oacute;n y confidencialidad, sin
					que para ello sea necesario obtener su autorizaci&oacute;n en
					t&eacute;rminos del art&iacute;culo 37 de la Ley Federal de
					Protecci&oacute;n de Datos Personales en Posesi&oacute;n de los
					Particulares. Para verificar los candados de seguridad SSL cookies y
					otras herramientas de rastreo a favor de visitar *seguridad de sitio*.
					Para verificar los cambios al presente aviso, lo podr&aacute; realizar
					en:</span
				>
			</p>
			<p>
				<a href="http://www.mobilracing.mx"
					><strong><span>www.mobilracing.mx</span></strong></a
				><strong><span>&nbsp;</span></strong>
			</p>
			<p>
				<a href="http://www.imakinando.mx"
					><strong><span>www.imakinando.mx</span></strong></a
				>
			</p>
		</div>
		<FooterBack></FooterBack>
	</div>
</template>
<script>
import FooterBack from "./components/FooterBack";
export default {
	name: "privacidad",
	components: {
		FooterBack,
	},
};
</script>
